<template>
    <base-modal
        @close="clearAndClose"
        :blur-bg="true"
        class="cz2__name-pop-modal"
    >
        <div class="cz2__name-pop-modal-content">
            <div class="cz2__modal-popup__header">
                {{ headingCopy }}
            </div>

            <p class="cz2__modal-popup__copy">
                Or, skip now and name later.
            </p>

            <div
                :aria-label="$t('NAME_MODAL_ALT_TEXT')"
                :style="{ backgroundImage: `url(${boxPreviewImage})` }"
                class="cz2__name-pop-modal-box"
            />

            <name-field
                :validate="validateCount"
                @done="doneValidating"
            />

            <div class="cz2__name-pop-modal__buttons">
                <btn
                    primary
                    :disabled="!name"
                    @click="triggerValidation"
                >
                    <loading-spinner
                        v-if="isValidating"
                        :spinner-size="19"
                    />
                    <span v-else>
                        {{ $t('NAME_CONFIRM') }}
                    </span>
                </btn>

                <btn
                    gray
                    @click="clearAndClose"
                >
                    {{ $t('NAME_SKIP') }}
                </btn>
            </div>

            <p class="cz2__name-pop-disclaimer">
                {{ $t('NAME_POP_DISCLAIMER') }}
            </p>
        </div>
    </base-modal>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__name-pop-modal {
            .cz2__base-modal-content-wrapper {
                height: 100%;
                width: 100%;
                max-width: 448px;
            }

            .cz2__modal-popup__header {
                margin-bottom: 8px;
            }

            .cz2__modal-popup__header {
                font-size: 38px;
            }

            .cz2__modal-popup__copy {
                margin-bottom: 16px;
                font-size: 16px;
            }

            .cz2__modal-popup__header,
            .cz2__modal-popup__copy {
                text-align: center;
            }

            .cz2__name-pop-modal-content {
                height: 100%;
                width: 100%;
                padding: 48px 24px 24px 24px;
                display: flex;
                flex-direction: column;
            }

            .cz2__name-pop-modal-box {
                margin-top: -16px;
                flex: 1 0%;
                width: 100%;
                background-position: center;
                background-size: contain;
                background-repeat: no-repeat;
            }

            .cz2__name-field-input {
                margin-bottom: 0;
            }

            .cz2__name-pop-modal__buttons {
                margin-top: 64px;
                display: flex;
                flex-direction: column;
                gap: 10px;

                .cz2__btn {
                    height: 40px;

                    &:hover {
                        font-size: 20px;
                    }
                }
            }

            .cz2__name-pop-disclaimer {
                margin-top: 16px;
                color: #707070;
                font-size: 13px;
                font-family: 'Proxima Nova', sans-serif;
                text-align: center;
            }

            @include respond-above(sm) {
                .cz2__base-modal-content-wrapper {
                    height: auto;
                }

                .cz2__name-pop-modal-box {
                    height: 224px;
                    flex: none;
                }
            }

            @include respond-above(lg) {
                .cz2__name-pop-modal-content {
                    padding: 48px 32px 24px 32px;
                }

                .cz2__name-pop-modal-box {
                    height: 232px;
                }

                .cz2__name-pop-modal__buttons {
                    margin-top: 80px;
                }
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__name-pop-modal {
            .cz2__base-modal-content-wrapper {
                max-width: 550px;

                .cz2__name-field-label {
                    font-size: 15px;
                }

                .cz2__name-pop-modal__buttons {
                    button {
                        height: 56px;
                    }
                }
            }

            .cz2__name-field-keyboard {
                position: fixed;
                bottom: 16px;
                left: 50%;
                transform: translateX(-50%);

                border: 2px solid rgba(141, 186, 237, 0.64);
                border-radius: 32px;
                padding: 32px;
                width: calc(100% - 32px);
                background-color: #275DA5;
            }
        }
    }
</style>

<script>
    import BaseModal from './ui/BaseModal.vue';
    import NameField from './NameField.vue';
    import Btn from './ui/Btn.vue';
    import LoadingSpinner from './ui/LoadingSpinner.vue';

    export default {
        components: {
            BaseModal,
            NameField,
            Btn,
            LoadingSpinner,
        },

        data() {
            return {
                validateCount: 0,
                isValidating: false,
            };
        },

        computed: {
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            name() {
                return this.$store.state.customizer.boxName;
            },

            isTwoPack() {
                return this.$store.getters.isTwoPack;
            },

            isFirstPop() {
                return this.viewController === this.$store.getters.popControllers[0];
            },

            headingCopy() {
                if (this.isTwoPack) {
                    if (this.isFirstPop) {
                        return this.$t('NAME_MODAL_HEADING_2_PACK');
                    }

                    return this.$t('NAME_MODAL_HEADING_POP_2');
                }

                return this.$t('NAME_MODAL_HEADING');
            },

            boxPreviewImage() {
                return this.$store.state.customizer.boxPreviewImage;
            },

            boxName() {
                return this.$store.state.customizer.boxName;
            },
        },

        mounted() {
            this.emitter.$on('cameraLoading', this.cameraLoading);

            // Update snapshots as selections are made.
            // this.viewController.on('stateChanged', () => {
            //     this.cameraLoading();
            // });
        },

        beforeDestroy() {
            this.emitter.$off('cameraLoading', this.cameraLoading);
        },

        watch: {
            boxName() {
                this.cameraLoading();
            },
        },

        methods: {
            triggerValidation() {
                this.validateCount += 1;
                this.isValidating = true;
            },

            doneValidating(isValid) {
                this.isValidating = false;

                if (isValid) {
                    this.close();
                }
            },

            clearAndClose() {
                // Clear any text the user might have entered
                this.$store.dispatch('updateBoxName', '');

                this.close();
            },

            close() {
                this.$store.dispatch('showNamePopModal', false);
            },

            cameraLoading(loading) {
                if (!loading) {
                    this.getBoxPreview();
                }
            },

            async getBoxPreview() {
                if (this.previewDebounce) {
                    clearTimeout(this.previewDebounce);
                }

                this.previewDebounce = setTimeout(async () => {
                    const boxImage = await this.$store.dispatch('snapshot', {
                        view: this.isTwoPack ? 'SnapshotBoxPack' : 'SnapshotBoxName',
                        // Render both pops.
                        onlyController: null,
                    });

                    this.$store.dispatch('setPreviewImages', {
                        boxPreviewImage: boxImage,
                    });
                }, 250);
            },
        },
    };
</script>
